export class TemplateApiError extends Error {
  status: number;
  code?: string;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.name = 'TemplateApiError';
    this.status = status;
    this.code = code;
  }
}

/** User-facing message; never exposes raw server internals. */
export function templateApiUserMessage(
  error: unknown,
  context: 'load' | 'mutate' = 'load'
): string {
  if (error instanceof Error && error.name === 'NoSessionError') {
    return 'Your session could not be verified. Please sign in again.';
  }
  if (error instanceof TemplateApiError) {
    if (error.status === 401) {
      return 'Your session could not be verified. Please sign in again.';
    }
    if (error.code === 'SCHEMA_MISSING') {
      return 'Template storage is not available right now.';
    }
  }
  return context === 'load'
    ? 'Templates could not be loaded right now.'
    : 'Template changes could not be saved. Please try again.';
}

export function isSchemaMissingError(status: number, message: string): boolean {
  if (status === 404 || status === 500 || status === 503) {
    return /schema cache|does not exist|relation .*listing_templates|could not find the table/i.test(
      message
    );
  }
  return false;
}

export function logTemplateApiFailure(
  operation: string,
  status: number,
  apiError: string | undefined
): void {
  if (process.env.NODE_ENV !== 'production') {
    console.error('[listing-templates]', {
      operation,
      status,
      apiError: apiError ?? null,
    });
  }
}
